import { useContext, useEffect } from "react"
import { Field } from "formik"
import { DateTime } from "luxon"
import _ from "lodash"

import { FormContext } from "../../../context/formContext"
import { Calendar } from "primereact/calendar"
import { transformDate } from "../../../helpers/dateNormalization"
import fieldVisibility from "../../../helpers/fieldVisibility"

import styles from "../../../styles/Form.module.css"

export default function TypeDemoBirthdate({ field, block, index }) {
  const form = useContext(FormContext)
  const isDisabled = form ? form.blocksSaved[block] : false
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  const now = DateTime.now()
  const handleMinDate = () => {
    const minAge = now.minus({ years: 101 })
    return minAge.toJSDate()
  }
  const handleMaxDate = () => {
    const maxAge = now.minus({ years: 12 })
    return maxAge.toJSDate()
  }

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && "*"}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => {
            let birthdate = ""
            const rawBirthdate = formikField.value
            let formattedBirthdate = null

            if (rawBirthdate?._seconds) {
              formattedBirthdate = rawBirthdate
            } else if (_.isDate(rawBirthdate)) {
              formattedBirthdate = DateTime.fromJSDate(rawBirthdate).toFormat(
                "yyyy-MM-dd",
              )
            }

            if (formattedBirthdate) {
              birthdate = transformDate(
                formattedBirthdate,
                field.field_type,
                field.field_type_subtype,
              )
            }

            return (
              <>
                <Calendar
                  name={formikField.name}
                  value={birthdate}
                  onChange={formikField.onChange}
                  disabled={isDisabled}
                  onBlur={formikField.onBlur}
                  maxDate={handleMaxDate()}
                  minDate={handleMinDate()}
                />
                {meta.touched && meta.error && (
                  <div className={styles.errFieldMsg}>{meta.error}</div>
                )}
              </>
            )
          }}
        </Field>
      </div>
    </div>
  )
}
